import { NavLink } from '@umijs/max';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import './index.less';

export const MenuItem: FC<
  {
    path:
      | string
      | Partial<{
          pathname: string;
          search: string;
          hash: string;
        }>;
    children: ReactNode | ((props: { isActive: boolean }) => ReactNode);
  } & Partial<{ secondary: boolean }>
> = (props) => {
  // props
  const { path, children, secondary } = props;

  return (
    <li className="flex-shrink-0 basis-10">
      <NavLink
        to={path}
        className={({ isActive }) =>
          classNames(
            `menu-item flex items-center h-full mx-3 ${
              secondary ? 'px-5' : 'px-3.5'
            } rounded-md transition`,
            {
              'menu-item--active text-primary': isActive,
            },
          )
        }
      >
        {children}
      </NavLink>
    </li>
  );
};
